<template>
  <div id="stockInquiry">
    <div class="searchBox">
      <div>
        <el-input
          v-model="stockForm.sysSearch"
          style="width: 200px"
          placeholder="输入商品名称"
        ></el-input>
        <el-button type="primary" @click="search" size="small">搜索</el-button>
      </div>
      <div class="mt10 alignCenter">
        <!-- <el-date-picker v-model="stockForm.dataTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="dataTimeChoose" value-format="yyyy-MM-dd"></el-date-picker> -->
        <el-select
          size="small"
          v-model="stockForm.synthesisOrderType"
          style="width:220px;"
        >
          <el-option
            v-for="item in synthesisOrderTypeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          v-model="stockForm.repositoryId"
          style="width:220px;"
          class="ml10"
          @change="repositoryIdChange"
        >
          <el-option
            v-for="item in repositoryList"
            :key="item.repositoryId"
            :label="item.repositoryName"
            :value="item.repositoryId"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          v-model="stockForm.goodsCategoryId"
          style="width:220px;"
          class="ml10"
        >
          <el-option
            v-for="item in goodsCategoryList"
            :key="item.goodsCategoryId"
            :label="item.categoryName"
            :value="item.categoryName"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          style="margin-left:10px"
          @click="deleteSearch"
          type="primary"
          >清除</el-button
        >
        <el-button
          size="small"
          style="margin-left:10px"
          @click="search"
          type="primary"
          >完成</el-button
        >
      </div>
      <!-- <div class="mt10">
                <el-select size="small" v-model="stockForm.saleStatus" style="width:220px;">
                    <el-option v-for="item in saleStatusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
                <el-select size="small" v-model="stockForm.isNoGoodsNum" style="width:220px;">
                    <el-option v-for="item in isNoGoodsNumList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
                <el-button size="small" style="margin-left:10px" @click="deleteSearch" type="primary">清除</el-button>
                <el-button size="small" style="margin-left:10px" @click="search" type="primary">完成</el-button>
            </div> -->
    </div>
    <div class="searchGroup">
      <div class="flex-row-start padding-center">
        <div class="flex-column pr20">
          <div>可用库存</div>
          <div class="text-color">{{ qrcTotalStockCount }}</div>
        </div>
        <div class="flex-column">
          <div>库存总额合计（元）</div>
          <div class="text-color">{{ toFixed(totalStockPrice) }}</div>
        </div>
      </div>
      <div class="mt40">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsName }} ({{ scope.row.valueContent }})
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="仓库"
            prop="repositoryName"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="qrcTotalStockCount"
            label="可用库存"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="totalStockPrice"
            label="库存总额"
          >
            <template slot-scope="scope">
              {{
                scope.row.isInfiniteStock == 1
                  ? "---"
                  : "￥" + scope.row.totalStockPrice
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="outputNum"
            label="出库量"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="inputNum"
            label="入库量"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button class="button5" @click="detail(scope.row)"
                >商品库存</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="queryInfo.pageNo"
            :page-size="queryInfo.row"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  repositoryList,
  goodsCategoryLists,
  repositoryGoodsQueryList,
  repositoryGoodsQuerylistTotalNum,
  getRepositoryTotalStatistic
} from "../api";
export default {
  data() {
    return {
      userList: {},
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      tableData: [],
      total: 0,
      stockForm: {
        sysSearch: "",
        month: "",
        dataTime: "",
        repositoryId: "",
        goodsCategoryId: "",
        synthesisOrderType: "",
        saleStatus: "",
        isNoGoodsNum: ""
      },
      status: "",
      repositoryList: [],
      goodsCategoryList: [],
      synthesisOrderTypeList: [
        { value: "", name: "全部排序" },
        // { value: 0, name: "创建日期"},
        { value: 1, name: "名称" },
        { value: 2, name: "库存量" },
        { value: 3, name: "库存额" }
      ],
      saleStatusList: [
        { value: "", name: "是否显示停用商品" },
        { value: 0, name: "显示" },
        { value: 1, name: "不显示" }
      ],
      isNoGoodsNumList: [
        { value: "", name: "是否显示零库存商品" },
        { value: 0, name: "显示" },
        { value: 1, name: "不显示" }
      ],
      qrcTotalStockCount: 0,
      totalStockPrice: 0,
      loading: false,
      repositoryId: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getRepositoryList();
    this.getRepositoryGoodsQueryList();
  },
  methods: {
    toFixed(x) {
      if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split("e-")[1]);
        if (e) {
          x *= Math.pow(10, e - 1);
          x = "0." + new Array(e).join("0") + x.toString().substring(2);
        }
      } else {
        var e = parseInt(x.toString().split("+")[1]);
        if (e > 20) {
          e -= 20;
          x /= Math.pow(10, e);
          x += new Array(e + 1).join("0");
        }
      }
      return x;
    },
    // 清空搜索内容
    deleteSearch() {
      this.stockForm = {};
      this.getRepositoryGoodsQueryList();
    },
    // 搜索
    search() {
      this.queryInfo.pageNo = 1;
      this.status = 1;
      if (this.stockForm.goodsCategoryId == "全部商品分类") {
        this.stockForm.goodsCategoryId = "";
      }
      this.getRepositoryGoodsQueryList(
        this.stockForm.sysSearch,
        this.startDate,
        this.endDate,
        this.stockForm.repositoryId,
        this.stockForm.goodsCategoryId,
        this.stockForm.synthesisOrderType
      );
    },
    detail(item) {
      console.log(item, "商品库存");
      this.$router.push({ path: "singleStockInquiry", query: { arr: item } });
      localStorage.setItem("arr", JSON.stringify(item));
    },
    // dataTimeChoose() {
    //     console.log(this.stockForm.dataTime)
    //     this.startDate = this.stockForm.dataTime[0]
    //     this.endDate = this.stockForm.dataTime[1]
    // },
    // 仓库
    getRepositoryList() {
      repositoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999
      }).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryList.unshift({
            repositoryId: "",
            repositoryName: "全部仓库"
          });
          // let index = this.repositoryList.findIndex(item => {
          //     return item.repositoryId == this.getCookie("defaultRepositoryId")
          // })
          // this.stockForm.repositoryId = this.repositoryList[index].repositoryId
          this.getGoodsCategoryList();
        }
      });
    },
    repositoryIdChange(val) {
      let index = this.repositoryList.findIndex(item => {
        return val == item.repositoryId;
      });
      console.log(index);
      this.getGoodsCategoryList(this.repositoryList[index].shopStoreId, val);
    },
    // 商品分类
    getGoodsCategoryList(shopStoreId) {
      goodsCategoryLists({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        queryType: 3,
        pageNo: 1,
        row: 9999,
        shopStoreId: shopStoreId
      }).then(res => {
        if (res.code == 1) {
          this.goodsCategoryList = res.data;
          // this.stockForm.goodsCategoryId = res.data[0].goodsCategoryId
          this.goodsCategoryList.unshift({
            goodsCategoryId: "",
            categoryName: "全部商品分类"
          });
        } else if (res.code == -1) {
          this.goodsCategoryList = [];
        } else {
        }
      });
    },
    // 库存查询列表
    getRepositoryGoodsQueryList(
      sysSearch,
      startDate,
      endDate,
      repositoryId,
      categoryName,
      synthesisOrderType
    ) {
      this.loading = true;
      repositoryGoodsQueryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        sysSearch: sysSearch,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        // goodsCategoryId: goodsCategoryId,
        categoryName: categoryName,
        synthesisOrderType: synthesisOrderType
      }).then(res => {
        this.loading = false;
        this.getRepositoryTotalStatistic(
          sysSearch,
          startDate,
          endDate,
          repositoryId,
          categoryName,
          synthesisOrderType
        );
        this.repositoryGoodsQuerylistTotalNum(
          sysSearch,
          startDate,
          endDate,
          repositoryId,
          categoryName,
          synthesisOrderType
        );
        if (res.code == 1) {
          this.tableData = res.data;
          for (var i in this.tableData) {
            if (this.tableData[i].isInfiniteStock == 1) {
              this.tableData[i].qrcTotalStockCount = "无限库存";
              this.tableData[i].totalStockPrice = "--";
            }
          }
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    handleSizeChange(newVal) {
      this.queryInfo.row = newVal;
      this.getRepositoryGoodsQueryList();
    },
    handleCurrentChange(newVal) {
      this.queryInfo.pageNo = newVal;
      if (this.status == 1) {
        if (this.stockForm.goodsCategoryId == "全部商品分类") {
          this.stockForm.goodsCategoryId = "";
        }
        this.getRepositoryGoodsQueryList(
          this.stockForm.sysSearch,
          this.startDate,
          this.endDate,
          this.stockForm.repositoryId,
          this.stockForm.goodsCategoryId,
          this.stockForm.synthesisOrderType
        );
      } else {
        this.getRepositoryGoodsQueryList();
      }
    },
    getRepositoryTotalStatistic(
      sysSearch,
      startDate,
      endDate,
      repositoryId,
      categoryName,
      synthesisOrderType
    ) {
      getRepositoryTotalStatistic({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        sysSearch: sysSearch,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        categoryName: categoryName,
        synthesisOrderType: synthesisOrderType
      }).then(res => {
        if (res.code == 1) {
          this.qrcTotalStockCount = res.data.qrcTotalStockCount;
          this.totalStockPrice = res.data.totalStockPrice;
        }
      });
    },
    repositoryGoodsQuerylistTotalNum(
      sysSearch,
      startDate,
      endDate,
      repositoryId,
      categoryName,
      synthesisOrderType
    ) {
      repositoryGoodsQuerylistTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        sysSearch: sysSearch,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        categoryName: categoryName,
        synthesisOrderType: synthesisOrderType
      }).then(res => {
        if (res.code == 1) {
          this.total = res.data.totalNum;
        }
      });
    }
  }
};
</script>

<style scoped>
.searchBox {
  width: calc(100vw - 210px);
  height: 174px;
  background: rgba(248, 248, 248, 1);
  position: absolute;
  top: 53px;
  padding: 20px;
  box-sizing: border-box;
}
.mt10 {
  margin-top: 10px;
}
.mt40 {
  margin-top: 40px;
}
.ml10 {
  margin-left: 10px;
}
.pr20 {
  padding-right: 20%;
  box-sizing: border-box;
}
.text-color {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(17, 17, 17, 1);
  padding-top: 5px;
  box-sizing: border-box;
}
.searchGroup {
  position: absolute;
  top: 241px;
  left: 221px;
  width: calc(100vw - 250px);
  height: 99px;
  background: rgba(248, 248, 248, 1);
}
.padding-center {
  padding: 20px;
  box-sizing: border-box;
}
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.flex-row-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style>
/* .el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
} */
/* .el-table th {
    background-color: #F2F3F2;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/stockInquiry.vue